import React, { useState } from 'react'
import { Form, Input } from 'antd'
import { AddButtonWarper } from './style'
import { AddButton } from '../../Category/styles'
import { useAppDispatch } from '../../../utils/hooks/redux';
import { createNoteByAdminForFound } from '../../../redux/features/activityLog/activityLogAsyncThunk';

export type AddCommentProps = {
    foundId: string | null | undefined;
};

const AddComment = ({ foundId }: AddCommentProps) => {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();

    const [loading, setLoading] = useState<boolean>(false);

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            const noteData = {
                foundId,
                ...values,
            };

            await dispatch(createNoteByAdminForFound(noteData));
            form.resetFields();
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Form disabled={loading} form={form} onFinish={onFinish}>
                <Form.Item name="note" rules={[{ required: true, message: "Please enter your comment!" }]}>
                    <Input.TextArea rows={4} placeholder="comment" />
                </Form.Item>
                <AddButtonWarper>
                    <AddButton htmlType="submit" type="primary" loading={loading}>Add comment</AddButton>
                </AddButtonWarper>
            </Form>
        </>
    )
}

export default AddComment
